"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCssUtil = void 0;
var theme_1 = require("./theme");
var IkeCssUtil = /** @class */ (function () {
    function IkeCssUtil() {
    }
    IkeCssUtil.absolute = function (top, left) {
        return { position: 'absolute', top: theme_1.DefaultTheme.space(top), left: theme_1.DefaultTheme.space(left) };
    };
    IkeCssUtil.padding = function (up, right, down, left) {
        if (right == null) {
            return { padding: theme_1.DefaultTheme.space(up) };
        }
        if (down == null) {
            return { padding: "".concat(theme_1.DefaultTheme.space(up), " ").concat(theme_1.DefaultTheme.space(right)) };
        }
        return { padding: "".concat(theme_1.DefaultTheme.space(up), " ").concat(theme_1.DefaultTheme.space(right), " ").concat(theme_1.DefaultTheme.space(down), " ").concat(theme_1.DefaultTheme.space(left)) };
    };
    IkeCssUtil.Font = {
        familyCondensed: {
            'font-family': theme_1.DefaultTheme.font.familyCondensed
        }
    };
    IkeCssUtil.Flex = {
        column: {
            display: 'flex',
            'flex-direction': 'column'
        },
        center: {
            display: 'flex',
            'justify-content': 'center',
            'align-items': 'center'
        },
        centerVertical: {
            display: 'flex',
            'align-items': 'center'
        }
    };
    return IkeCssUtil;
}());
exports.IkeCssUtil = IkeCssUtil;
//# sourceMappingURL=theme.util.js.map